import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShoppingCartList, putShoppingCart, deleteShoppingCart as deleteShoppingCartAPI } from 'Api/endpoints/ShoppingCart';
import { useError } from 'Api/hooks/useError';
import { setLoading } from 'Actions';

const useShoppingCart = () => {
  const { defaultField } = useSelector(state => state.config);
  const [items, setItems] = useState([]);
  const { showErrorPopup } = useError();
  const dispatch = useDispatch();

  const getShoppingCart = useCallback(async () => {
    if (!defaultField?._id) return;
    try {
      const result = await getShoppingCartList(defaultField?._id);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      setItems(result.data);
    } catch (e) {
      console.log(e);
    }
  }, [defaultField?._id, showErrorPopup]);

  useEffect(() => {
    getShoppingCart();
  }, [getShoppingCart]);

  const saveShoppingCart = useCallback(
    async (data, callback) => {
      if (!defaultField?._id) return;
      try {
        dispatch(setLoading(true));
        const result = await putShoppingCart(defaultField?._id, data);
        if (result.err) {
          showErrorPopup({ text: result.err.response.data.message });
          return;
        }
        await getShoppingCart();
        callback && callback();
      } catch (e) {
        console.log(e);
      } finally {
        dispatch(setLoading(false));
      }
    },
    [defaultField?._id, showErrorPopup, dispatch, getShoppingCart]
  );

  const deleteShoppingCart = useCallback(
    async (data, callback) => {
      if (!defaultField?._id) return;
      try {
        dispatch(setLoading(true));
        const result = await deleteShoppingCartAPI(defaultField?._id, data);
        if (result.err) {
          showErrorPopup({ text: result.err.response.data.message });
          return;
        }
        await getShoppingCart();
        callback && callback();
      } catch (e) {
        console.log(e);
      } finally {
        dispatch(setLoading(false));
      }
    },
    [defaultField?._id, showErrorPopup, dispatch, getShoppingCart]
  );

  return { shoppingCart: items, saveShoppingCart, deleteShoppingCart, refreshShoppingCart: getShoppingCart };
};

export default useShoppingCart;
